import history from '@/history';

enum GOTO_TYPE {
  NEW_TAB,
  FORCEUPDATE,
  PUSH,
  REPLACE,
}

/**
 *
 * @param pathname 要跳转的地址
 * @param newtab 是否新开页面
 * @param forcereload 是否强制刷新跳转
 * @param fallback 是否有离开前确认
 */
export default function goTo(
  pathname: string,
  loadType: GOTO_TYPE = GOTO_TYPE.PUSH // newtab forceupdate push replace
) {
  const οnbefοreunlοadacore = (window as any).οnbefοreunlοadacore;
  if (!οnbefοreunlοadacore || typeof οnbefοreunlοadacore !== 'function') {
    pureGoto(pathname, loadType);
  } else {
    οnbefοreunlοadacore(() => pureGoto(pathname, loadType));
  }
}

function pureGoto(pathname: string, loadType: GOTO_TYPE = GOTO_TYPE.PUSH) {
  switch (loadType) {
    case GOTO_TYPE.NEW_TAB:
      window.open(pathname);
      break;
    case GOTO_TYPE.PUSH:
      history.push(pathname);
      break;
    case GOTO_TYPE.REPLACE:
      history.replace(pathname);
      break;
    case GOTO_TYPE.FORCEUPDATE:
      window.location.href = pathname;
      break;
    default:
      history.push(pathname);
  }
}

export { GOTO_TYPE, pureGoto };
